<template>
    <div id="">
        <ul class="listGoods" v-if="res_productList.length" ref="js_guessYouLike">
            <li class="listGoods-item" v-for="(row, index) in res_productList" :key="index">
                <a :href="'/proDetail_1217.html?prodId=' + row.id" @click="dp_recommendClick({
                        commodity_id: row.id,
                        commodity_name: row.name,
                        commodity_brand: row.showBrand,
                        percommodity_price: row.secooPrice,
                        price_tag: row.priceTag,
                        commodity_tag: '',
                        property_tag: row.tags.join('|'),
                        request_id: res_requestId,
                        position: index,
                        screen_name: from,
                        recommend_name: '猜你喜欢'
                    })" >
                    <div class="listGoods-imgBox" :data-src="getImgSrcByIsWebpSupport(row.picUrl, index)">
                        <div class="listGoods-imgWrp"></div>
                        <img v-if="false" class="listGoods-activeIcon" src=""  />
                        <div class="listGoods-presell" v-if="row.preSaleDesc && row.preSaleDescInfo">
                            <span class="listGoods-presellText">{{row.preSaleDesc}}</span>
                            <span class="listGoods-presellMsg">{{row.preSaleDescInfo}}</span>
                        </div>
                        <p class="listGoods-sales"
                            :class="{presell: row.preSaleDesc && row.preSaleDescInfo && row.promotionTags && row.promotionTags[0] }"
                            v-if="row.promotionTags && row.promotionTags[0]"
                            >{{row.promotionTags[0].tagName}}</p>
                        <span v-if="row.isAd" class="listGoods-iconAd" :class="{hasPromotion: row.promotionTags && row.promotionTags[0]}">广告</span>
                    </div>
                    <div class="listGoods-info">
                        <h3 class="listGoods-brand">{{ row.showBrand }}</h3>
                        <p class="listGoods-name">
                            {{ row.name }}
                        </p>
                        <p class="listGoods-price">
                            <template v-if="row.refPrice">
                                <span class="listGoods-initPrice">￥{{ row.refPrice | getInt | formatNum }}{{ String(row.refPrice).split('.').length > 1 ? '.' : '' }}</span>
                                <i class="listGoods-decimalPrice">{{ row.refPrice | getDecimal }}</i>
                            </template>
                            <template v-else>
                                <span class="listGoods-initPrice">￥{{ row.secooPrice | getInt | formatNum }}{{ String(row.secooPrice).split('.').length > 1 ? '.' : '' }}</span>
                                <i class="listGoods-decimalPrice">{{ row.secooPrice | getDecimal }}</i>
                            </template>
                            <span class="listGoods-priceLabel listGoods-vipLabel" v-if="row.refPriceType === 1"></span>
                            <span class="listGoods-priceLabel listGoods-tagLabel" v-else-if="row.refTag">
                                <em>{{ row.refTag }}</em>
                            </span>
                        </p>
                        <p class="listGoods-pricing" :class="{'listGoods-isLine': row.isLine}" v-if="row.tipPrice">
                            <span class="listGoods-tipPrice">￥{{ row.tipPrice | formatNum }}</span>
                            <span class="listGoods-priceLabel listGoods-vipLabel" v-if="row.tipPriceType === 1"></span>
                        </p>
                        <!-- <p class="listGoods-labels" v-if="row.tags && row.tags.length">{{ row.tags.length && row.tags.join(' / ') }}</p> -->
                        <p class="listGoods-labels" v-if="row.tags && row.tags.length">
                            <span :style="{visibility: 'hidden'}" v-for="(tag, tagIndex) in row.tags">{{ row.tags | tagsFormat(tagIndex) }}</span>
                        </p>
                    </div>
                </a>
            </li>
        </ul>
        <ul class="listGoods" v-else>
            <li class="listGoods-item" v-for="num in 10">
                <div class="listGoods-imgBox"></div>
                <div class="listGoods-info" style="padding: 0 0">
                    <p class="line line1"></p>
                    <p class="line line2"></p>
                    <p class="line line3"></p>
                    <p class="line line4"></p>
                    <p class="line line5"></p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
//引入组件
import MDialog from '@/components/MDialog';

//引入JS
import { mapMutations, mapActions } from 'vuex';
let SEC = require('common/js/utils/core.js');

//引入配置
import {
    getImgSrcByIsWebpSupport // 根据是否支持图片模式webp，计算图片地址
} from '@/public/js/public.js';

//引入API接口
import {
    api_getRecommend, //猜你喜欢
} from '@/api';

export default {
    name: "",
    props: {
        // 调用接口地址
        api: {
            type: Function,
            default: api_getRecommend
        },

        // 调用接口数据
        data: {
            type: Object,
            default(){
                return {
                    type: 'search',
                    count: 10
                }
            }
        },

        // 调用来源
        from: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        doPointEvents: [
            'recommendClick', // 事件名：推荐点击
        ],

        // 是否支持图片webp格式
        isWebpSupport: (localStorage.getItem('isWebpSupport') ? true : false),

        res_requestId: '', // 请求ID
        res_productList: [] //猜你喜欢
    }),
    created(){
        this.api_getRecommend(); //猜你喜欢
    },
    mounted(){

    },
    updated() {
        // 计算显示合适标签组
        this.computedShowListGoodsLabels();
    },
    methods: {
        // 计算显示合适标签组
        computedShowListGoodsLabels() {
            let oGuessYouLike = this.$refs.js_guessYouLike;
            if (oGuessYouLike) {
                let aLiItems = oGuessYouLike.querySelectorAll('.listGoods-item');
                let oListGoodsBrand = oGuessYouLike.querySelector('.listGoods-brand');
                let boxWidth = Math.floor(oListGoodsBrand.offsetWidth);

                aLiItems.forEach(oLiItem => {
                    let oLabel = oLiItem.querySelector('.listGoods-labels');
                    if (oLabel) {
                        let aSpan = oLabel.querySelectorAll('span');
                        let len = aSpan.length;
                        let isTrue = false; // 标识位，是否找到符合条件的元素

                        for (let i = 0; i < len; i++) {
                            let oSpan = aSpan[i];
                            let spanWidth = oSpan.offsetWidth;

                            // 找到符合条件的选项后，让其显示（找到第一个符合条件的选项后，不再查找别的）其它直接删除；
                            if (spanWidth < boxWidth && !isTrue) {
                                oSpan.style.visibility = 'visible';
                                isTrue = true;
                            } else {
                                oSpan.parentNode.removeChild(oSpan);
                            }
                        }
                    }
                });
            }
        },

        //猜你喜欢
        api_getRecommend(){
            this.api(
                this.data
            ).then(
                res => {
                    let data = res.body || {};

                    // data.productList[0].tags = ['每满10万减500', '每满10万减500', '多件多折', '自营'];
                    // data.productList[1].tags = ['满赠', '分期免息', '多件多折', '自营'];
                    // data.productList[2].tags = ['满赠', '分期免息', '多件多折', '非自营'];
                    // data.productList[3].tags = ['满赠', '每满80000减2000', '多件多折', '非自营'];

                    if (!data.retMsg) {
                        this.res_requestId = data.requestId;
                        this.res_productList = data.productList || [];
                    } else {
                        this.show_alert({
                            content: data.retMsg
                        });
                    }
                    // console.log(this.res_productList);
                },
                error => {
                    this.show_alert({
                        content: '亲，您的网络不给力吆'
                    });
                }
            ).then(() => {
                this.initImgLoad();
            });
        },

        initImgLoad(){
            let aImgBox = document.querySelectorAll('.listGoods-imgBox[data-src]'),
                vH = document.documentElement.clientHeight || document.body.clientHeight,
                arrImgBox = [];

            for(let i=0, l=aImgBox.length; i<l; i++){
                arrImgBox.push(aImgBox[i]);
            }

            for(let i=0; i<arrImgBox.length; i++){
                let oImgBox = arrImgBox[i],
                    src = oImgBox.getAttribute('data-src'),
                    oImgWrp = oImgBox.querySelector('.listGoods-imgWrp'),
                    pos = oImgBox.getBoundingClientRect(),
                    top = pos.top,
                    bottom = pos.bottom;

                //console.log(i, arrImgBox.length, oImgBox);

                //console.log(top, bottom);
                if(top < vH && bottom > 0){ //在可视区内
                    oImgWrp.innerHTML = `<img src="${ src }" style="display: block;" width="100%" height="100%" />`;
                    oImgBox.removeAttribute('data-src');
                    arrImgBox.splice(i, 1);
                    --i;
                }
            }
        },

        // 根据是否支持图片模式webp，计算图片地址
        getImgSrcByIsWebpSupport,

        // 打点统计: recommendClick事件
        dp_recommendClick (properties) {
            sensors.track(
                this.doPointEvents[0],
                properties
            );
        },

        showAlert(data){
            this.$store.dispatch('show_alert', data);
        },
        ...mapMutations({
            set_alert_show: 'SET_ALERT_SHOW',
            set_alert_hide: 'SET_ALERT_HIDE',
            set_alert_data: 'SET_ALERT_DATA',
            set_confirm_show: 'SET_CONFIRM_SHOW',
            set_confirm_hide: 'SET_CONFIRM_HIDE',
            set_confrim_data: 'SET_CONFIRM_DATA'
        }),
        ...mapActions([
            'show_alert'
        ])
    },
    filters: {
        formatNum(num){
            let arr = String(num).split('.');
            return arr[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,') + (arr.length > 1 ? '.' + arr[1] : '');
        },
        getInt(num){
            let arr = String(num).split('.');
            return arr[0];
        },
        getDecimal(num){
            if(~String(num).indexOf('.')){
                return String(num.toFixed(2)).split('.')[1];
            }else{
                return '';
            }
        },
        tagsFormat(tags = [], index) {
            let copyTags = [ ...tags ];
            let len = copyTags.length;

            // 1. 先将自营、非自营放到数组的末尾
            // let targetIndex = copyTags.findIndex(item => {
            //     return item.indexOf('自营') !== -1
            // });
            // if (~targetIndex) {
            //     copyTags = copyTags.concat(copyTags.splice(targetIndex, 1));
            // }
            // console.log(copyTags);

            // 2. 再进行筛选
            let start = len - (index + 1);
            let delLen = index;

            copyTags.splice(start, delLen);
            return copyTags.join(' / ');
        },
    }
}
</script>
<style lang="scss" scoped>
.listGoods {
    @extend %flex-horizontal-between;

    font-size: toRem(24);

    &-item {
        overflow: hidden;
        padding-bottom: toRem(60);
        width: toRem(374);
    }
    &-imgWrp,
    &-imgWrp img {
        display: block;
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }
    &-imgBox {
        position: relative;
        height: toRem(374);
    }
    &-activeIcon,
    &-presell,
    &-sales,
    &-iconAd {
        position: absolute;
    }
    &-activeIcon {
        top: toRem(20);
        left: toRem(20);

        width: toRem(86);
        height: toRem(86);
    }
    &-presell,
    &-sales {
        bottom: 0;
        left: 0;

        @include box-sizing(border-box);

        text-align:  center;

        color: #FFF;
    }
    &-presell {
        z-index: 100;

        padding: 0 toRem(18) 0 toRem(4);
        width: toRem(150);
        height: toRem(64);

        background-image: url(../../public/img/presell.png);

        background-size: 100% 100%;
    }
    &-presellText,
    &-presellMsg {
        display: block;

        font-size: toRem(20);
        line-height: toRem(28);
    }
    &-presellText,
    &-sales {
        overflow: hidden;
        @extend %text-ellipsis;
    }
    &-presellText {
        padding: toRem(5) toRem(10) 0 0;

        height: toRem(28);
    }
    &-presellMsg {
      white-space: nowrap;
    }
    &-sales {
        padding: toRem(7) toRem(4) 0;
        width: 100%;
        height: toRem(44);

        font-size: toRem(22);
        line-height: toRem(30);

        background-image: -webkit-linear-gradient(-90deg, #FF953E 0%, #FF2626 98%);
        background-image: linear-gradient(-90deg, #FF953E 0%, #FF2626 98%);
        background-size: 100% 100%;

        &.presell {
            padding-left: toRem(144);
        }
    }
    &-iconAd {
        bottom: toRem(52);
        right: toRem(10);

        width: toRem(48);
        height: toRem(26);

        font-size: toRem(18);
        line-height: toRem(26);
        text-align: center;

        color: #FFF;
        background: rgba(0,0,0,0.20);
        @include border-radius(2px);

        &.hasPromotion {
            bottom: toRem(52);
        }
    }
    &-info {
        padding: 0 toRem(30);
    }
    &-brand,
    &-name,
    &-labels {
        overflow: hidden;
        @extend %text-ellipsis;
    }
    &-brand {
        margin-top: toRem(50);
        height: toRem(32);

        line-height: toRem(32);
    }
    &-name {
        margin-top: toRem(8);
        height: toRem(44);

        line-height: toRem(44);
    }
    &-price {
        margin-top: toRem(20);
        height: toRem(48);

        font-size: toRem(34);
        line-height: toRem(34);
        white-space: nowrap;
    }
    &-initPrice,
    &-decimalPrice,
    &-priceLabel,
    &-tipPrice,
    &-tipPriceLabel {
        vertical-align: middle;
    }
    &-decimalPrice {
        font-size: toRem(22);
    }
    &-vipLabel {
        width: toRem(62);
        height: toRem(25);

        background: url(../../public/img/vipTag.png) center left no-repeat;
    }
    &-tagLabel {
        // margin-left: toRem(10);

        padding: 0 toRem(6) 0 toRem(10);
        height: toRem(30);

        font-size: toRem(20);
        line-height: toRem(30);
        color: #E50000;

        background: url(../../public/img/border.png) center left no-repeat;
    }
    &-priceLabel {
        display: inline-block;

        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;

        & em {
            display: inline-block;
            // @include transform(scale(0.833333, 0.833333));
            font-style: normal;
        }
    }
    &-pricing {
        margin-top: toRem(2);
        height: toRem(40);

        font-size: toRem(28);
        line-height: toRem(40);
        color: $color-main;

        white-space: nowrap;
    }
    &-isLine {
        color: $color-gray;

        font-size: toRem(26);
        text-decoration: line-through;
    }
    &-labels {
        margin-top: toRem(14);
        height: toRem(34);

        line-height: toRem(34);

        color: $color-gold;
    }
}
.line {
    margin-top: 0.3rem;
    height: 0.3rem;
    background: #f8f8f8;

    &1 {
        margin-top: 0.5rem;
        width: 1.5rem;
    }
    &2 {
        width: 4.5rem;
    }
    &3 {
        width: 3.2rem;
    }
    &4 {
        width: 2.3rem;
    }
    &5 {
        width: 3.6rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/MGoodsList/index.vue